<div class="detail-container">
  <nb-card>
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>TGA</h5>
      @if (canEdit() && !isNew()) {
        <wr-edit-delete-button-group
          (edit)="onEdit()"
          (delete)="buildingEquipmentDetailFormComponent?.onDelete()">
        </wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      <nb-tabset class="vertical-tabset" (changeTab)="onTabChange($event)">

        <nb-tab tabTitle="Grunddaten">
          @if (buildingEquipmentReady()) {
            <wr-building-equipment-detail-form
              [showCard]="false"
              [showTitle]="false"
              [showCollections]="false"
              [showFooter]="false"
              [disableEdit]="true"
              [buildingEquipment]="buildingEquipment"
              [buildingAndSection]="buildingAndSection()"
              (cancelled)="cancel()"
              (submitSuccess)="onSubmitSuccess($event)"
              (deleteSuccess)="onDeleteSuccess()">
            </wr-building-equipment-detail-form>
          }
        </nb-tab>

        @if (!isNew()) {
          <nb-tab tabTitle="Felder">
            <wr-building-equipment-fields-tab></wr-building-equipment-fields-tab>
          </nb-tab>
        }

        @if (buildingEquipment && viewMaintenanceTimers() && !isNew()) {
          <nb-tab tabTitle="Wartungstimer">
            @if (buildingEquipmentReady()) {
              <wr-maintenance-timer-overview
                [buildingEquipment]="buildingEquipment!">
              </wr-maintenance-timer-overview>
            }
          </nb-tab>
        }

        @if (buildingEquipmentId() && !isNew()) {
          <nb-tab tabTitle="Protokolle">
            <wr-building-equipment-protocols-tab
              [buildingEquipmentId]="buildingEquipmentId()!">
            </wr-building-equipment-protocols-tab>
          </nb-tab>
        }

        @if (!isNew() && buildingEquipment) {
          <nb-tab tabTitle="Reparaturaufträge">
            <wr-building-equipment-repair-tasks-tab [buildingEquipment]="buildingEquipment">
            </wr-building-equipment-repair-tasks-tab>
          </nb-tab>
        }

        @if (!isNew() && buildingEquipmentId() && canViewFolderContents() && buildingEquipment) {
          <nb-tab tabTitle="Dokumente">
            @if (buildingEquipment.tgaDocumentsAccess === 'NO_SCOPE') {
              <wr-banner status="warning"
                         data-cy="tga-documents-no-scope"
                         [icon]="{ icon: 'lock-outline', pack: 'eva' }"
                         message="Keine Freigabe für TGA-Ordner – der Eigentümer kann sie unter Dienstleister → Zugriffe erteilen."></wr-banner>
            } @else {
              <wr-building-equipment-folders-tab
                [buildingEquipmentId]="buildingEquipmentId()!"
                [isEditing]="isEditing()">
              </wr-building-equipment-folders-tab>
            }
          </nb-tab>
        }

      </nb-tabset>
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing() || isSaving()" nbButton status="primary"
                (click)="submit()">Speichern
        </button>
        <button size="medium" [disabled]="!isEditing() || isSaving()" nbButton status="basic"
                (click)="cancel()">Abbrechen
        </button>
      </nb-card-footer>
    }
  </nb-card>
</div>
